// session
export const UPDATE_LOGIN_SESSION = 'UPDATE_LOGIN_SESSION';
export const UPDATE_USER_LOGGING_IN = 'UPDATE_USER_LOGGING_IN';
export const UPDATE_LOGIN_ERROR = 'UPDATE_LOGIN_ERROR';

export const makeAction = (type, payload) => ({ type, payload });


// WEBPACK FOOTER //
// ./src/actions/index.js